import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const modalContent = css`
  padding: ${size[32]} ${size[24]};

  ${breakpoint.up('sm')} {
    padding: ${size[64]} ${size[48]};
  }
`

export const modalContentButtons = css`
  display: grid;
  margin-top: ${size[32]};
  grid-column-gap: ${size[16]};
  grid-template-columns: 1fr 1fr;
`

export const buttons = css`
  display: flex;
  flex-direction: row;
  grid-column-gap: ${size[16]};
`
